import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { useMount, useReactive } from "ahooks";
import URI from "urijs";
import useActiveState from "../../../lib/useActiveState";
import Dialog from "../../../lib/Dialog";
import { CopyToClipboard } from "react-copy-to-clipboard/lib/Component";
import { CSSTransition, TransitionGroup } from "react-transition-group";

import Getter from "./Getter";
import Guide from "./Guide";
import Reserve from "./Reserve";
import Tips from "./Tips";
import Image from "../../../lib/Image";

const { aplus_queue } = window;

const Main = ({ game, close }) => {
  const [app] = useActiveState("app");
  const [udid] = useActiveState("udid");
  const data = useReactive({
    udidGetter: undefined,
    interval: undefined,
    state: undefined,
    reserve: undefined,
    tips: undefined,
    url: undefined,
    frequency: 1,
  });

  const history = useHistory();

  let [progressNum, setProgressNum] = useState(0);
  let [record, setRecord] = useState([]);
  const [downUrl, setDownUrl] = useState("");
  const ws = useRef(null);
  const isClose = useRef(false);
  useMount(() => {
    if (udid) {
      data.interval = 3000;
      connectWebSocket();

      aplus_queue.push({
        action: "aplus.record",
        arguments: [
          "download",
          "download",
          {
            type: "vip",
            state: "start",
            gameId: game?.game_id,
            agent: localStorage.getItem("agent"),
            username: localStorage.getItem("username"),
          },
        ],
      });
    }
  });

  const connectWebSocket = () => {
    // Dialog.loading("请求中...");
    let appId = game?.game_url?.super_ios_url.split("app_id")[1].split("/")[1];
    console.log("appId---------", appId);

    if (!game?.maiyou_gameid) {
      Dialog.error("缺少必要参数gameid，请重试");
      return;
    }

    // if (!localStorage.getItem("agent")) {
    //   Dialog.error("缺少必要参数agent，请重试");
    //   return;
    // }

    if (!udid) {
      Dialog.error("缺少必要参数udid，请重试");
      return;
    }

    let params = `game_id=${game?.maiyou_gameid}&app_id=${appId || ""}&agent=${
      localStorage.getItem("agent") || "x7z1"
    }&user_id=${localStorage.getItem("user_id") || ""}&username=${
      localStorage.getItem("username") || ""
    }&http_udid=${udid}&type=superios`;

    console.log("params---------", params);

    // iossupersign.9917.cn   cdniossupersign.9917.cn
    ws.current = new WebSocket(
      "wss://iossupersign.9917.cn/api/v1/process?" + params
    );

    // 断开连接重连
    ws.current.onclose = (event) => {
      console.log("连接断开", event);
    };

    // 出错重连
    ws.current.onerror = (event) => {
      console.log("连接出错", event);

      console.log("isclose------------", isClose.current);
      if (!isClose.current) {
        if (data.frequency < 4) {
          setTimeout(() => {
            data.frequency += 1;
            Dialog.info("连接断开，正在重新连接");
            connectWebSocket();
          }, 3000);
        } else {
          Dialog.error("连接失败，请检查网络情况，稍后重试~");
          data.interval = undefined;
          close();
        }
      }
    };

    // 当连接被打开时，注册接收消息的处理函数
    ws.current.onopen = () => {
      console.log("打开啦----------");
      heartCheck.reset().start();

      ws.current.onmessage = (event) => {
        heartCheck.reset().start();

        console.log("接收到消息-----", event.data);

        if (event.data === "Ping") {
          return;
        }

        const data = JSON.parse(event.data);
        // Dialog.close();
        if (data.code === 200) {
          if (data.msg == "progressing" || data.msg == "progressed") {
            // 更新进度条

            let num = Number(Number(data.progress).toFixed(2) * 100).toFixed(0);
            console.log(num);
            progressNum = num;
            setProgressNum(num);

            record.push(data.progress);
            setRecord([...record]);

            if (record[0] != 1) {
              console.log(record);
              console.log("展示进度条----------");
              setDownUrl("show");
            }

            if (data.data.url) {
              console.log(data.data.url);
              aplus_queue.push({
                action: "aplus.record",
                arguments: [
                  "download",
                  "download",
                  {
                    type: "vip",
                    state: "success",
                    gameId: game?.game_id,
                    agent: localStorage.getItem("agent"),
                    username: localStorage.getItem("username"),
                  },
                ],
              });
              data.interval = undefined;

              if (navigator.userAgent == "app") {
                window.location.href = URI("app://browser")
                  .addQuery("url", data.data.url)
                  .toString();
              } else {
                window.location.href = data.data.url;
              }
              if (!data.data.super) {
                data.tips = true;
                data.url = data.data.url;
                return;
              }

              heartCheck.reset();
              ws.current?.close();
              setTimeout(() => {
                Dialog.close();
                close();
              }, 1000);
            }
          } else {
            Dialog.info(data.msg);
            heartCheck.reset();
            ws.current?.close();
            close();
          }
        } else {
          Dialog.info(data.msg);
          heartCheck.reset();
          ws.current?.close();
          close();
        }
      };
    };
  };

  // 心路包
  const heartCheck = useReactive({
    timeout: 5000,
    timeoutObj: null,
    serverTimeoutObj: null,
    reset: function () {
      clearTimeout(this.timeoutObj);
      clearTimeout(this.serverTimeoutObj);
      return this;
    },
    start: function () {
      let self = this;
      // 5s执行一次该代码
      this.timeoutObj = setTimeout(function () {
        if (ws.current.readyState === WebSocket.OPEN) {
          console.log("发送心路包---------");
          ws.current.send("Ping");
        }

        // 如果超过5s serverTimeoutObj还没重置，说明断开了
        self.serverTimeoutObj = setTimeout(function () {
          console.log("心路包重连");
          data.frequency += 1;
          connectWebSocket(); // 重连
        }, self.timeout);
      }, this.timeout);
    },
  });

  useEffect(() => {
    history.listen((location) => {
      // console.log("请求路由路径变化了", location);
      heartCheck.reset();
      isClose.current = true;
      ws.current?.close();
      // data.interval = undefined;
      // close();
    });
  });

  return (
    <>
      {udid ? (
        <>
          {data.interval && downUrl ? (
            <TransitionGroup>
              <CSSTransition timeout={250}>
                <div className="game-new-super">
                  <div className="new-super-main">
                    <div
                      className="cancel-btn"
                      onClick={() => {
                        Dialog.affirm(
                          "温馨提示",
                          <div style={{ textAlign: "center" }}>
                            您确定取消游戏下载？
                          </div>,
                          () => {
                            heartCheck.reset();
                            isClose.current = true;
                            ws.current?.close();
                            data.interval = undefined;
                            close();
                          },
                          () => {
                            Dialog.close();
                          },
                          {
                            close: "确定",
                            affirm: "继续等待",
                          }
                        );
                      }}
                    >
                      取消
                    </div>
                    <div className="super-game-msg">
                      <Image src={game?.game_image?.thumb} />
                      <div className="name">
                        {game?.game_name_main || game?.game_name}
                        {game?.game_name_branch &&
                          " - " + game?.game_name_branch}
                      </div>
                    </div>
                    <div className="super-game-progress">
                      <div
                        className="progress"
                        id="progress"
                        style={{ width: progressNum + "%" }}
                      ></div>
                      <div className="font">
                        分包签名中，勿退出{progressNum}%
                      </div>
                    </div>
                    <div className="tips">
                      <ExclamationCircleOutlined
                        style={{ marginRight: "2px", fontSize: "0.28rem" }}
                      />
                      请不要离开此页面并保持屏幕常亮
                    </div>
                    <div className="udid-msg">
                      <span>UDID：{udid}</span>

                      <CopyToClipboard
                        text={udid}
                        onCopy={() => Dialog.info("已复制")}
                      >
                        <p>复制</p>
                      </CopyToClipboard>
                    </div>
                  </div>
                </div>
              </CSSTransition>
            </TransitionGroup>
          ) : null}
        </>
      ) : (
        <>
          <Getter close={close} />
        </>
      )}
      {data.reserve ? (
        <>
          <Reserve game={game} close={close} />
        </>
      ) : null}
      {data.tips ? (
        <>
          <Tips url={data.url} close={close} />
        </>
      ) : null}
    </>
  );
};

export default (props) => {
  return (
    <>
      <Guide>
        <Main {...props} />
      </Guide>
    </>
  );
};
